import SearchUGCForm from './search-ugc-form'

export default SearchUGCForm;